import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../common/material.module';

import { WelcomeComponent } from './welcome.component';
import { WelcomeService } from './welcome.service';

import { LocalizationModule } from 'angular-l10n';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { NgxChartsDagModule } from '@swimlane/ngx-charts-dag';
import { TooltipModule } from 'ngx-tooltip';



@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    LocalizationModule,
    NgxChartsModule,
    NgxGraphModule,
    MaterialModule,
    NgxChartsDagModule,
    TooltipModule
  ],
  providers: [WelcomeService],
  declarations: [WelcomeComponent]
})
export class WelcomeModule { }



// WEBPACK FOOTER //
// ./src/app/views/welcome/welcome.module.ts